import { handleQuotations } from "../cotizaciones/cotizaciones";
import { formatNumber, getDocumentLabel } from "../utils";
import moment from "moment";
export const getTitleCase = (str = "") => {
  let exclude = ["del", "de", "la", "da", "el"];
  return str
    .toLowerCase()
    .split(" ")
    .map((person) => {
      return exclude.includes(person)
        ? person
        : person.length
        ? person[0].toUpperCase() + person.slice(1)
        : ``;
    })
    .join(" ");
};

const handleTypeState = (data, simulation) => {
  const { codigoPago} = data;
  const codigoAgrupador = data.codigoPago !== null && data.codigoPago !== undefined ? codigoPago : "-";
  const validateAgrupador = data.codigoPago !== null && data.codigoPago !== undefined;

  const handleDateAgrupador = () => {
    if (codigoAgrupador === "-") return;
    const { fechaVencimiento } = codigoAgrupador;
    const dataTime = new Date(fechaVencimiento);
    const tiempo = dataTime.getHours() <= 12 ? " a. m." : " p. m.";
    const timeAgrupador = `${dataTime.getHours() + 5}:${dataTime.getMinutes()} ${tiempo}`;
    const dateFormatter = new Intl.DateTimeFormat("es-Pe");
    const formattedDate = dateFormatter.format(dataTime);
    return `Vence el ${formattedDate} a las ${timeAgrupador}`;
  }

  const TYPES = {
    firmado: [
      {
        quote: "Estado",
        data: data.estado,
        label: true,
      },
      // {
      //   quote: "Código de pago",
      //   data:  validateAgrupador ?  handleDateAgrupador() : "-",
      //   label: false,
      // },
      { adjuntar: true },
    ],
    porFirmar: [
      {
        quote: "Estado",
        data: data.estado,
        label: true,
      },
    ],
    errPago: [
      {
        quote: "Estado",
        data: data.estado,
        label: true,
      },
    ],
    Vencida: [
      {
        quote: "Estado",
        data: data.estado,
        label: true,
      },
    ],
    errEmitida: [
      {
        quote: "Estado",
        data: data.estado,
        label: true,
      },
      {
        quote: "Fecha de revisión",
        data: data.fechaRevision ? data.fechaRevision.replaceAll("-", "/") : "",
      },
      {
        quote: "Detalle del error",
        data:
          data.datosEmision && data.datosEmision.mensaje
            ? data.datosEmision.mensaje
            : "Error de emisión",
      },
    ],
    pendiente: [
      {
        quote: "Estado",
        data: data.estado,
        label: true,
      },
    ],
    emitida: [
      {
        quote: "Estado",
        data: data.estado,
        label: true,
      },
      {
        quote: "Fecha de revisión",
        data:
          data.fechaRevision && data.fechaRevision.replaceAll("-", "/")
            ? data.fechaRevision.replaceAll("-", "/")
            : "",
      },
      {
        quote: "Fecha de emisión",
        data:
          data.datosEmision && data.datosEmision.fecEmision.replaceAll("-", "/")
            ? data.datosEmision.fecEmision.replaceAll("-", "/")
            : "",
      },
      {
        quote: "Número de póliza",
        data:
          data.datosEmision && data.datosEmision.numPoliza
            ? data.datosEmision.numPoliza
            : "-",
      },
    ],
    suscrita: [
      {
        quote: "Suscrita",
        data: data.estado,
        label: true,
      },
    ],
    rechazada: [
      {
        quote: "Estado",
        data: data.estado,
        label: true,
      },
      {
        quote: "Fecha de revisión",
        data:
          data.fechaRevision && data.fechaRevision.replaceAll("-", "/")
            ? data.fechaRevision.replaceAll("-", "/")
            : "-",
      },
      {
        quote: "Motivo de rechazo",
        data:
          data.rejection && data.rejection.reason ? data.rejection.reason : "-",
      },
      {
        quote: "Comentario",
        data:
          data.rejection && data.rejection.comment
            ? data.rejection.comment
            : "",
      },
    ],
    vencida: [
      {
        quote: "Estado",
        data: data.estado,
        label: true,
      },
      {
        quote: "Fecha de revisión",
        data: "-",
      },
      {
        quote: "Fecha de vencimiento",
        data:
          simulation.vencimiento && simulation.vencimiento.replaceAll("-", "/")
            ? simulation.vencimiento.replaceAll("-", "/")
            : "-",
      },
    ],
    enFila: [
      {
        quote: "Estado",
        data: data.estado,
        label: true,
      },
      {
        quote: "Fecha de revisión",
        data:
          data.fechaRevision && data.fechaRevision.replaceAll("-", "/")
            ? data.fechaRevision.replaceAll("-", "/")
            : "-",
      },
    ],
    revision: [
      {
        quote: "Estado",
        data: data.estado,
        label: true,
      },
    ],
  };

  return TYPES;
};

export const cardProducts = (
  data,
  tramaCoti,
  firstName,
  lastName,
  clientData,
  sexCli,
  dirCli,
  herederos
) => {
  const simulation = data.datosSimulacion || data.datosCotizacion;

  const validateData = data.datosCliente.tipoDoc.nombre === null ? data.asegurado : data.datosCliente;
  const {
    producto: { codigo },
  } = data;

  let datosGenerales;
  const cobAdicionales = simulation.cobAdicionales ? "Si" : "No";
  const dpsData = simulation.dpsAfirmativa
    ? simulation.dpsAfirmativa
    : simulation.dps;

  const {
    tasa,
    prima,
    primaTotal,
    periodo,
    moneda: { iso },
  } = simulation;

  const {
    datosCliente: { portafolio },
  } = data;

  const yearPeriodo = periodo === 1 ? "año" : "años";

  const { primaBase, primaAhorro, sumaAsegurada } = handleQuotations(
    simulation,
    codigo
  );

  const codigoProducto = {
    AS: "Ahorro Seguro",
    IG: "Inversión Global",
    RG: "Renta Garantizada",
    UC: "Inversión Global Ultra Cash",
  };

  const sumaAseguradaUC =
    `${simulation.moneda.simbolo} ` +
    formatNumber.new(simulation.sumaAsegurada ? simulation.sumaAsegurada : 0);

  const nombreProducto = codigoProducto[codigo] || "";
  const TYPES = handleTypeState(data, simulation);
  const modifier = TYPES[data.estado];

  const dataRevision = {
    title: "DATOS DE REVISIÓN",
    items: modifier || [
      {
        quote: "Estado",
        data: data.estado,
        label: true,
      },
    ],
    beneficiary: [],
  };
  if (codigo === "IG") {
    datosGenerales = {
      title: "DATOS DE COTIZACIÓN",
      items: [
        {
          quote: "Producto",
          data: nombreProducto,
        },
        {
          quote: "Portafolio",
          data: simulation.portafolio || portafolio,
        },
        {
          quote: "Prima comercial",
          data:
            `${simulation.moneda.simbolo} ` +
            formatNumber.new(simulation.prima),
        },
        primaBase,
        primaAhorro,
        {
          quote: "Período de póliza",
          data: `${simulation.duracionPoliza || simulation.plazo} ${
            simulation.plazo === 1 ? "año" : "años"
          }`,
        },
        { quote: "Cobertura", data: "Fallecimiento" },
        {
          quote: "DPS",
          data: dpsData ? "Positiva" : "Negativa",
        },
        sumaAsegurada,
      ],
      beneficiary: [],
    };
  }
  if (codigo === "RG") {
    datosGenerales = {
      title: "DATOS DE SIMULACIÓN",
      items: [
        {
          quote: "Producto",
          data: nombreProducto,
        },
        {
          quote: "Portafolio",
          data: simulation.portafolio || portafolio,
        },
        {
          quote: "Prima comercial",
          data:
            `${simulation.moneda.simbolo} ` +
            formatNumber.new(simulation.prima),
        },
        primaBase,
        primaAhorro,
        {
          quote: "Período de póliza",
          data: `${simulation.duracionPoliza || simulation.aniosTemp} ${
            simulation.aniosTemp === 1 ? "año" : "años"
          }`,
        },
        { quote: "Cobertura", data: "Fallecimiento" },
        {
          quote: "DPS",
          data: dpsData ? "Positiva" : "Negativa",
        },
        sumaAsegurada,
      ],
      beneficiary: [],
    };
  }
  if (codigo === "UC") {
    datosGenerales = {
      title: "DATOS DE COTIZACIÓN",
      items: [
        {
          quote: "Producto",
          data: nombreProducto,
        },
        {
          quote: "Portafolio",
          data: simulation.portafolio || portafolio,
        },
        {
          quote: "Prima comercial",
          data:
            `${simulation.moneda.simbolo} ` +
            formatNumber.new(simulation.prima),
        },
        {
          quote: "Periodo",
          data: `${simulation.duracionPoliza || simulation.plazo} ${
            simulation.duracionPoliza || simulation.plazo <= 1 ? "año" : "años"
          }`,
        },
        {
          quote: "Cobertura",
          data: "Fallecimiento",
        },
        {
          quote: "DPS",
          data: dpsData ? "Positiva" : "Negativa",
        },
        {
          quote: "Suma asegurada por fallecimiento",
          data: sumaAseguradaUC,
        },
        // {
        //   quote: "Suma asegurada por fallecimiento accidental",
        //   data: `${simulation.moneda.simbolo} ` + (simulation.sumaAseguradaAcc !== null ?  formatNumber.new(simulation.sumaAseguradaAcc) : formatNumber.new(0)),

        // },
      ],
      beneficiary: [],
    };
  }
  if (codigo === "AS") {
    datosGenerales = {
      title: "DATOS DE COTIZACIÓN",
      items: [
        {
          quote: "Producto",
          data: nombreProducto,
        },
        {
          quote: "Prima Total",
          data: `${iso} ${formatNumber.new(prima)}`,
        },
        {
          quote: "Retorno Total",
          data: `${iso} ${formatNumber.new(primaTotal)}`,
        },
        {
          quote: "Periodo",
          data: `${periodo} ${yearPeriodo}`,
        },
        {
          quote: "Tasa",
          data: tasa + "%",
        },
        {
          quote: "Coberturas adicionales",
          data: cobAdicionales,
        },
      ],
      beneficiary: [],
    };
  }

  let contratante = {}

  if(data.contratante){
    if( Object.keys(data.contratante).length === 0){
      const contractor = {
        title: "DATOS DEL CONTRATANTE",
            items: [
        { quote: "Nombres", data: firstName },
        { quote: "Apellidos", data: lastName },
        {
          quote: data.datosCliente.tipoDoc.nombre === null ? validateData.typeDoc.nombre : data.datosCliente.tipoDoc.nombre,
          data: data.datosCliente.documento,
        },
        { quote: "Fecha de nacimiento", data: clientData.birthdate },
        { quote: "Sexo", data: sexCli },
        { quote: "Celular", data: clientData.mobile },
        { quote: "Correo electrónico", data: clientData.email },
        {
          quote: "Dirección",
          data: `${getTitleCase(dirCli)}.`,
        },
      ],
      beneficiary: [],
      };
  
      contratante = {...contractor}
    } else if(data.contratante.typeContractor === 'ENTITY'){
      const contractorTypeEntity = {
        title: "DATOS DEL CONTRATANTE",
        items: [
          { quote: "Razón Social", data: data.contratante.companyName
          },
          {
            quote: 'RUC: ',
            data: data.contratante.nroDoc,
          },
          {
            quote: 'Giro: ',
            data: data.contratante.giro,
          },
          {
            quote: 'Correo: ',
            data: data.contratante.email,
          },
          {
            quote: 'Dirección: ',
            data: data.contratante.address || '',
          }
        ],
        beneficiary: [],
      };
      contratante = {...contractorTypeEntity}
    } else if(data.contratante.typeContractor === 'PERSON'){
      const contractorTypePërson = {
        title: "DATOS DEL CONTRATANTE",
        items: [
        { quote: "Nombres", data: data.contratante.names },
        { quote: "Apellidos", data: data.contratante.firstName + data.contratante.lastName },
        {
          quote: data.contratante.typeDoc ? getDocumentLabel(data.contratante.typeDoc) : '--',
          data: data.contratante.nroDoc,
        },
        { quote: "Sexo", data: data.contratante.sexo },
        { quote: "Celular", data: data.contratante.phone },
        { quote: "Correo electrónico", data: data.contratante.email },
      ],
        beneficiary: [],
      };
  
      contratante = {...contractorTypePërson}
    }
  } else {
const contratanteSimple = {
    title: "DATOS DEL CONTRATANTE",
    items: [
      { quote: "Nombres", data: firstName },
      { quote: "Apellidos", data: lastName },
      {
        quote: data.datosCliente.tipoDoc.nombre === null ? validateData.typeDoc.nombre : data.datosCliente.tipoDoc.nombre,
        data: data.datosCliente.documento,
      },
      { quote: "Fecha de nacimiento", data: clientData.birthdate },
      { quote: "Sexo", data: sexCli },
      { quote: "Celular", data: clientData.mobile },
      { quote: "Correo electrónico", data: clientData.email },
      {
        quote: "Dirección",
        data: `${getTitleCase(dirCli)}.`,
      },
    ],
    beneficiary: [],
  };

  contratante = {...contratanteSimple}
  }
  

  const beneficiario = {
    title: "DATOS DE BENEFICIARIOS",
    items: [],
    beneficiary: herederos,
  };

  const datoBackOffice = {
    title: "DATOS BACK OFFICE",
    items: [
      {
        quote: "Estado de biometria",
        data: data.casos && data.casos.estadoAutenticacionBiometrica ? data.casos.estadoAutenticacionBiometrica : '--',
      },
      {
        quote: "ID CASO",
        data: data.casos && data.casos.idCaso ? data.casos.idCaso : '--',
      },
      {
        quote: "Fecha de Revisión",
        data: data.casos && data.casos.fechaEnvioCasoBiometrico ? moment(data.casos.fechaEnvioCasoBiometrico).format("DD/MM/YYYY") : '--',
      }
    ],
    beneficiary: [],
  };

  if (data.estado === "Vigente") {
    if( data.casos && Object.keys(data.casos).length > 0) {
      tramaCoti = [datosGenerales, contratante, beneficiario, datoBackOffice];
    } else {
      tramaCoti = [datosGenerales, contratante, beneficiario];
    }
  } else {
    

    if( data.casos && Object.keys(data.casos).length > 0) {
      tramaCoti = [dataRevision, datosGenerales, contratante, beneficiario, datoBackOffice];
    } else {
      tramaCoti = [dataRevision, datosGenerales, contratante, beneficiario];
    }

  }

  return tramaCoti;
};

export const cardProductsSimulations = (
  data,
  tramaCoti,
  fullName
) => {
  const simulation = data.datosSimulacion || data.datosCotizacion;
  const {
    producto: { codigo },
  } = data;

  let datosGenerales;
  const cobAdicionales = simulation.cobAdicionales ? "Si" : "No";
  const dpsData = simulation.dpsAfirmativa ?  simulation.dpsAfirmativa : simulation.dps

  const {
    tasa,
    prima,
    primaTotal,
    periodo,
    moneda: { iso },
  } = simulation;

  const yearPeriodo = periodo === 1 ? "año" : "años";

  const { primaBase, primaAhorro, sumaAsegurada } = handleQuotations(
    simulation,
    codigo
  );

  const codigoProducto = {
    AS: "Ahorro Seguro",
    IG: "Inversión Global",
    RG: "Renta Garantizada",
    UC: "Inversión Global Ultra Cash",
  };

  const sumaAseguradaUC =
    `${simulation.moneda.simbolo} ` +
    formatNumber.new(simulation.sumaAsegurada ? simulation.sumaAsegurada : 0);

  const nombreProducto = codigoProducto[codigo] || "";
  const TYPES = handleTypeState(data, simulation);
  const modifier = TYPES[data.estado];

  const dataRevision = {
    title: "DATOS DE REVISIÓN",
    items: modifier || [
      {
        quote: "Estado",
        data: data.estado,
        label: true,
      },
    ],
    beneficiary: [],
  };

  if (codigo === "IG") {
    datosGenerales = {
      title: "DATOS DE COTIZACIÓN",
      items: [
        {
          quote: "Producto",
          data: nombreProducto,
        },
        {
          quote: "Prima comercial",
          data:
            `${simulation.moneda.simbolo} ` +
            formatNumber.new(simulation.prima),
        },
        primaBase,
        primaAhorro,
        {
          quote: "Período de póliza",
          data: `${simulation.duracionPoliza || simulation.plazo} ${
            simulation.plazo === 1 ? "año" : "años"
          }`,
        },
        { quote: "Cobertura", data: "Fallecimiento" },
        {
          quote: "DPS",
          data: dpsData ? "Positiva" : "Negativa",
        },
        sumaAsegurada,
      ],
      beneficiary: [],
    };
  }
  if (codigo === "RG") {
    datosGenerales = {
      title: "DATOS DE SIMULACIÓN",
      items: [
        {
          quote: "Producto",
          data: nombreProducto,
        },
        {
          quote: "Prima comercial",
          data:
            `${simulation.moneda.simbolo} ` +
            formatNumber.new(simulation.prima),
        },
        primaBase,
        primaAhorro,
        { quote: "Cobertura", data: "Fallecimiento" },
        {
          quote: "DPS",
          data: dpsData ? "Positiva" : "Negativa",
        },
        sumaAsegurada,
      ],
      beneficiary: [],
    };
  }
  if (codigo === "UC") {
    datosGenerales = {
      title: "DATOS DE COTIZACIÓN",
      items: [
        {
          quote: "Producto",
          data: nombreProducto,
        },
        {
          quote: "Prima comercial",
          data:
            `${simulation.moneda.simbolo} ` +
            formatNumber.new(simulation.prima),
        },
        {
          quote: "Periodo",
          data: `${simulation.duracionPoliza || simulation.plazo} ${
            simulation.duracionPoliza || simulation.plazo <= 1 ? "año" : "años"
          }`,
        },
        {
          quote: "Cobertura",
          data: "Fallecimiento",
        },
        {
          quote: "DPS",
          data: dpsData ? "Positiva" : "Negativa",
        },
        {
          quote: "Suma asegurada por fallecimiento",
          data: sumaAseguradaUC,
        },
      ],
      beneficiary: [],
    };
  }
  if (codigo === "AS") {
    datosGenerales = {
      title: "DATOS DE COTIZACIÓN",
      items: [
        {
          quote: "Producto",
          data: nombreProducto,
        },
        {
          quote: "Prima Total",
          data: `${iso} ${formatNumber.new(prima)}`,
        },
        {
          quote: "Retorno Total",
          data: `${iso} ${formatNumber.new(primaTotal)}`,
        },
        {
          quote: "Periodo",
          data: `${periodo} ${yearPeriodo}`,
        },
        {
          quote: "Tasa",
          data: tasa + "%",
        },
        {
          quote: "Coberturas adicionales",
          data: cobAdicionales,
        },
      ],
      beneficiary: [],
    };
  }

  let contratante = {}

  if(data.contratante){
    if(Object.keys(data.contratante).length === 0){
      const contractor = {
        title: "DATOS DEL CONTRATANTE",
        items: [
          { quote: "Nombres", data: fullName },
          {
            quote: data.datosCliente.tipoDoc.nombre,
            data: data.datosCliente.documento,
          }
        ],
        beneficiary: [],
      };
  
      contratante = {...contractor}
    } else if(data.contratante.typeContractor === 'ENTITY'){
      const contractorTypeEntity = {
        title: "DATOS DEL CONTRATANTE",
        items: [
          { quote: "Razón Social", data: data.contratante.companyName
          },
          {
            quote: 'RUC: ',
            data: data.contratante.nroDoc,
          },
          {
            quote: 'Giro: ',
            data: data.contratante.giro,
          },
          {
            quote: 'Correo: ',
            data: data.contratante.email,
          },
          {
            quote: 'Dirección: ',
            data: data.contratante.address || '',
          }
        ],
        beneficiary: [],
      };
      contratante = {...contractorTypeEntity}
    } else if(data.contratante.typeContractor === 'PERSON'){
      const contractorTypePërson = {
        title: "DATOS DEL CONTRATANTE",
        items: [
          { quote: "Nombres", data: data.contratante.names + ' ' +  data.contratante.firstName + ' ' + data.contratante.lastName},
          {
            quote: data.contratante.typeDoc ? getDocumentLabel(data.contratante.typeDoc) : '--',
            data: data.contratante.nroDoc,
          }
        ],
        beneficiary: [],
      };
  
      contratante = {...contractorTypePërson}
    }
  
  } else {
    const Simplecontractor = {
      title: "DATOS DEL CONTRATANTE",
      items: [
        { quote: "Nombres", data: fullName },
        {
          quote: data.datosCliente.tipoDoc.nombre,
          data: data.datosCliente.documento,
        }
      ],
      beneficiary: [],
    };
    contratante = {...Simplecontractor}
  }
  const beneficiario = {
    title: "DATOS DE BENEFICIARIOS",
    items: [],
    beneficiary: [],
  };


  if (data.estado === "Vigente") {
    tramaCoti = [dataRevision, datosGenerales, contratante ];
  } else {
    tramaCoti = [dataRevision, datosGenerales, contratante];
  }

  return tramaCoti;
};

export const handleTransformDataAprovations = (modalData) => {
  let cardCoti = [];
  let tramaCoti = []
  const data = modalData;
  const client = data.datosCliente;

  if(client){
  const beneficiary = client ? client.beneficiarios.personalizados : null;
  const clientData = client ? client.datosParticulares : null;
  const nameCli = clientData.names;
  const ApeCli = clientData.firstName.concat(" ", clientData.lastName);
  const firstName = nameCli ? getTitleCase(nameCli) : "";
  const lastName = ApeCli ? getTitleCase(ApeCli) : "";
  const sexCli = clientData.sexo === "F" ? "Femenino" : "Masculino";
  const urbanization = clientData.address.urbanization
    ? `, Urb. ${clientData.address.urbanization}`
    : clientData.address.urbanization;
  const dirCli = clientData.address.type.concat(
    ". ",
    clientData.address.name,
    ", ",
    clientData.address.number,
    " ",
    urbanization,
    ", ",
    clientData.address.nameUbigeo.district
  );
  let herederos = [];
    if (beneficiary.length > 0 && beneficiary[0].nombres !== "") {
      beneficiary.map((heredero) =>
        herederos.push({
          nombre: heredero.nombres,
          apellido: heredero.apePaterno.concat(" ", heredero.apeMaterno),
          tipoDoc: heredero.tipoDoc,
          dni: heredero.documento,
          fecNacimiento: heredero.fecNacimiento,
          sexo: heredero.sexo === "F" ? "Femenino" : "Masculino",
          numCelular: heredero.numCelular,
          correoElectronico: heredero.correoElectronico,
          relacion: heredero.relacion,
          beneficio: heredero.porcentaje,
        })
      );
    }
    cardCoti = cardProducts(data, tramaCoti, firstName, lastName, clientData, sexCli, dirCli, herederos);
  }
  
    
    return cardCoti;
}

export const handleTransformDataSimulations = (modalData) => {

  let cardCoti = [];
  let tramaCoti = []
  const data = modalData;
  const client = data.datosCliente;

  if(client) {
    const fullName = client.nombres;
    cardCoti = cardProductsSimulations(data, tramaCoti, fullName);
  }
  return cardCoti;
}

export const transformInsuredData = (insuredData, extraData) => {
  return {
    ASEG_AMERICANO: insuredData.residentUSA === '0' ? 'No' : 'Si',
    ASEG_US_TIN: insuredData.usTin,
    ASEG_OBLIGATIONS_ABROAD: insuredData.obligationsAbroad === '0' ? 'No' : 'Si',
    ASEG_OBLIGATIONS_ABROAD_LIST: insuredData.obligationsAbroadList,
    ASEG_APELL_MAT: extraData.lastName,
    ASEG_APELL_PAT: extraData.firstName,
    ASEG_CELULAR: insuredData.mobile,
    ASEG_CLA_AMERICANO: '',
    ASEG_COD_CIUDAD: insuredData.address.department,
    ASEG_DEPARTAMENTO: '',
    ASEG_DEPTO_INTERIOR: insuredData.address.apartment,
    ASEG_DIRECCION: insuredData.address.name,
    ASEG_DISTRITO: insuredData.address.district,
    ASEG_ESTADOCIVIL: insuredData.civilStatus,
    ASEG_FECHANAC: extraData.birthdate,
    ASEG_EDAD: '',
    ASEG_FUMADOR: '',
    ASEG_ID_SALUD: '',
    ASEG_ID_SEXO: extraData.sexo,
    ASEG_MAIL: insuredData.email,
    ASEG_MZ_LOTE: '',
    ASEG_NACIONALIDAD: insuredData.nationality,
    ASEG_NOMBRES: extraData.names,
    ASEG_NOMBRE_VIA: insuredData.address.name,
    ASEG_NUM_DOC: extraData.document,
    ASEG_NUM_VIA: insuredData.address.number,
    ASEG_PAIS: insuredData.country,
    ASEG_PROVINCIA: insuredData.address.province,
    ASEG_REFERENCIA: insuredData.address.reference,
    ASEG_REL_CONTRATANTE: '',
    ASEG_RESIDENCIA: '',
    ASEG_TELEFONO: insuredData.phone,
    ASEG_TIPO_DOC: extraData.typeDoc,
    ASEG_TIPO_VIA: insuredData.address.type,
    ASEG_UBIGEO: insuredData.address.nameUbigeo,
    ASEG_URBANIZACION: insuredData.address.urbanization,
    ASEG_PROFESION: insuredData.profession,
    ASEG_OCUPACION: insuredData.occupation
  }
}

export const transformLegalData = (legalData, extraData) => {
  return {
    JUR_CELULAR: legalData.cellphone,
    JUR_COD_CIUDAD: legalData.address.department,
    JUR_DEPARTAMENTO: '',
    JUR_DEPTO_INTERIOR: legalData.address.apartment,
    JUR_DIRECCION: legalData.address.name,
    JUR_DISTRITO: legalData.address.district,
    JUR_GIRO: legalData.giro,
    JUR_MAIL: legalData.email,
    JUR_MZ_LOTE: '',
    JUR_NOMBRE_VIA: legalData.address.name,
    JUR_NUM_VIA: legalData.address.number,
    JUR_PROVINCIA: legalData.address.province,
    JUR_RAZONSOCIAL: extraData.companyName,
    JUR_REFERENCIA: legalData.address.reference,
    JUR_RUC: extraData.nroDoc,
    JUR_TELEFONO: legalData.phone,
    JUR_TIPO_VIA: legalData.address.type,
    JUR_UBIGEO: legalData.address.nameUbigeo,
    JUR_URBANIZACION: legalData.address.urbanization
  }
}

export const transformLegalRepresentativeData = (LegalRepresentativeData, extraData) => {
  return {
    REP_AMERICANO: LegalRepresentativeData.isAmericanResident,
    REP_APELL_MAT: LegalRepresentativeData.lastNameMother,
    REP_APELL_PAT: LegalRepresentativeData.lastNameFather,
    REP_CELULAR: LegalRepresentativeData.cellphoneRep,
    REP_CLA_AMERICANO: "",
    REP_COD_CIUDAD: LegalRepresentativeData.addressv2.department,
    REP_DEPARTAMENTO: '',
    REP_DEPTO_INTERIOR: LegalRepresentativeData.addressv2.apartment,
    REP_DIRECCION: LegalRepresentativeData.addressv2.name,
    REP_DISTRITO: LegalRepresentativeData.addressv2.distric,
    REP_ESTADOCIVIL: LegalRepresentativeData.civilStatus,
    REP_FECHANAC: LegalRepresentativeData.fecNacimiento,
    REP_EDAD: '',
    REP_ID_SEXO: LegalRepresentativeData.sexo,
    REP_MAIL: LegalRepresentativeData.emailRep,
    REP_MZ_LOTE: '',
    REP_NACIONALIDAD: LegalRepresentativeData.nationality,
    REP_NOMBRES: LegalRepresentativeData.name,
    REP_NOMBRE_VIA: LegalRepresentativeData.addressv2.name,
    REP_NUM_DOC: LegalRepresentativeData.nroDoc,
    REP_NUM_VIA: LegalRepresentativeData.addressv2.number,
    REP_PAIS: LegalRepresentativeData.countryOfResidence,
    REP_PROVINCIA: LegalRepresentativeData.addressv2.province,
    REP_REFERENCIA: LegalRepresentativeData.addressv2.reference,
    REP_RESIDENCIA: '',
    REP_TELEFONO: '',
    REP_TIPO_DOC: LegalRepresentativeData.typeDoc,
    REP_TIPO_VIA: LegalRepresentativeData.addressv2.type,
    REP_UBIGEO: LegalRepresentativeData.addressv2.nameUbigeo,
    REP_URBANIZACION: LegalRepresentativeData.addressv2.urbanization
  }
}

export const transformNaturalData = (naturalData, extraData) => {
  return {
    NAT_AMERICANO: naturalData.residentUSA,
    NAT_US_TIN: naturalData.usTin,
    NAT_OBLIGATIONS_ABROAD: naturalData.obligationsAbroad === '0' ? 'No' : 'Si',
    NAT_OBLIGATIONS_ABROAD_LIST: naturalData.obligationsAbroadList,
		NAT_APELL_MAT: extraData.lastName,
		NAT_APELL_PAT: extraData.firstName,
		NAT_CELULAR: naturalData.mobile,
		NAT_CLA_AMERICANO: '',
		NAT_COD_CIUDAD: naturalData.address.department,
		NAT_DEPARTAMENTO: '',
		NAT_DEPTO_INTERIOR: naturalData.address.apartment,
		NAT_DIRECCION: naturalData.address.name,
		NAT_DISTRITO: naturalData.address.district,
		NAT_ESTADOCIVIL: naturalData.civilStatus,
		NAT_FECHANAC: naturalData.birthdate,
		NAT_EDAD: '',
		NAT_FUMADOR: 'N',
		NAT_ID_SALUD: '',
		NAT_ID_SEXO: extraData.sexo,
		NAT_MAIL: naturalData.email,
		NAT_MZ_LOTE: '',
		NAT_NACIONALIDAD: naturalData.nationality,
		NAT_NOMBRES: extraData.names,
		NAT_NOMBRE_VIA: naturalData.address.name,
		NAT_NUM_DOC: extraData.nroDoc,
		NAT_NUM_VIA: naturalData.address.number,
		NAT_PAIS: naturalData.country,
		NAT_PROVINCIA: naturalData.address.province,
		NAT_REFERENCIA: naturalData.address.reference,
		NAT_REL_CONTRATANTE: '',
		NAT_RESIDENCIA: '',
		NAT_TELEFONO: naturalData.phone,
		NAT_TIPO_DOC: extraData.typeDoc,
		NAT_TIPO_VIA: naturalData.address.type,
		NAT_UBIGEO: naturalData.address.nameUbigeo,
		NAT_URBANIZACION: naturalData.address.urbanization,
		NAT_PROFESION: naturalData.profession,
		NAT_OCUPACION: naturalData.occupation
  }
}